import EditIcon from "./EditIcon";

type Props = {
    src: string
};

const Avatar = ({src}: Props) => {
    if (!src) {
        return (<></>)
    }

    return (
        <div className='avatar-container editable'>
            <img alt='avatar' className="img-fluid rounded-circle text-center" src={src} style={{maxWidth: '150px'}}/>
            <EditIcon></EditIcon>
        </div>
    )
}

export default Avatar;
